if(!customElements.get('header-dropdown')) {
  class HeaderDropdown extends HTMLElement {
    constructor() {
      super();
      this.level = Number(this.dataset.level);
      this.opener = this.querySelector(`[data-opener-level="${this.level}"]`);
      this.content = this.querySelector(`[data-opener-level="${this.level}"] + div`);

      this.bindEvents();
      this.setupAccessibility();
    }

    setupAccessibility() {
      if (!this.opener || !this.content) return;

      // Make opener focusable and add ARIA attributes
      if (!this.opener.hasAttribute('tabindex')) {
        this.opener.setAttribute('tabindex', '0');
      }

      // Set up ARIA relationship
      this.opener.setAttribute('role', 'button');
      this.opener.setAttribute('aria-expanded', this.hasAttribute('open') ? 'true' : 'false');

      if (!this.content.id) {
        this.content.id = `dropdown-content-${Math.random().toString(36).substr(2, 9)}`;
      }
      this.opener.setAttribute('aria-controls', this.content.id);

      // Set content region role
      this.content.setAttribute('role', 'region');
      this.content.setAttribute('aria-labelledby', this.opener.id || this.content.id + '-opener');

      if (!this.opener.id) {
        this.opener.id = this.content.id + '-opener';
      }

      // Initialize tab order based on current state
      this.updateTabOrder();
    }

    /**
     * Updates the tab order of focusable elements inside the dropdown content
     */
    updateTabOrder() {
      if (!this.content) return;

      const focusableElements = this.content.querySelectorAll(
        'a[href], button:not([disabled]), textarea:not([disabled]), input:not([disabled]), select:not([disabled]), [tabindex]:not([tabindex="-1"]), [contenteditable="true"]'
      );

      if (this.hasAttribute('open')) {
        // Dropdown is open - restore tab order
        focusableElements.forEach(element => {
          if (element.hasAttribute('data-original-tabindex')) {
            const originalTabindex = element.getAttribute('data-original-tabindex');
            if (originalTabindex === 'null') {
              element.removeAttribute('tabindex');
            } else {
              element.setAttribute('tabindex', originalTabindex);
            }
            element.removeAttribute('data-original-tabindex');
          }
        });
      } else {
        // Dropdown is closed - remove from tab order
        focusableElements.forEach(element => {
          // Store original tabindex value
          const currentTabindex = element.getAttribute('tabindex');
          element.setAttribute('data-original-tabindex', currentTabindex || 'null');
          // Remove from tab order
          element.setAttribute('tabindex', '-1');
        });
      }
    }

    getHeight() {
      const openers = this.querySelectorAll(`[data-opener-level="${this.level + 1}"]`);

      if(!openers.length) return this.content.scrollHeight;

      let height = 0;
      openers.forEach(opener => height += opener.scrollHeight);
      return height;
    }

    toggle() {
      if(this.hasAttribute('open')) {
        this.close();
      } else {
        this.open();
      }
    }

    open() {
      if (!this.hasAttribute('open')) {
        this.setAttribute('open', '');
        this.opener.setAttribute('aria-expanded', 'true');
        this.contentInitialHeight = this.getHeight();
        this.content.style.height = this.contentInitialHeight + 'px';

        // Update tab order to include content elements
        this.updateTabOrder();
      }
    }

    close() {
      if (this.hasAttribute('open')) {
        this.removeAttribute('open');
        this.opener.setAttribute('aria-expanded', 'false');
        this.content.style.height = '0px';

        // Update tab order to exclude content elements
        this.updateTabOrder();
      }
    }

    bindEvents() {
      this.querySelectorAll('.menu-drawer__back-button').forEach((button) =>  {
        button.addEventListener('click', (event) => {
          this.closest('header-dropdown').removeAttribute('open')
        })
      });

      // Add keyboard support to the opener
      if (this.opener) {
        this.opener.addEventListener('keydown', (event) => {
          switch (event.key) {
            case 'Enter':
            case ' ':
              event.preventDefault();
              this.toggle();
              break;
          }
        });
      }
    }

    connectedCallback() {
      if(!this.level || !this.opener || !this.content) return;

      this.contentInitialHeight = this.getHeight();

      this.content.style.height = '0px';

      this.opener.addEventListener('click', (event) => {
        event.stopPropagation();
        this.toggle();
      });
    }
  }

  customElements.define('header-dropdown', HeaderDropdown);
}
